import React, { useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { createSelector } from "reselect";

// Actions
import { fetchPushStudyToRemote } from "../../actions";

// MUI Components
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Typography from "@material-ui/core/Typography";
import CircularProgress from "@material-ui/core/CircularProgress";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Box from "@material-ui/core/Box";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
// Other Files
import { customTheme } from "../../constants/customTheme";
import { colors } from "../../constants/colors";
import classNames from "classnames";
import { remoteStatus } from "../../constants/constants";
import { getCloudStatusIcon } from "../../constants/utilityFunctions";

const useStyles = makeStyles({
  root: (props) => ({
    ...customTheme(props.theme).dialog.root,
    width: "calc(100% - 40px)",
    maxWidth: "calc(100% - 40px)",
    height: "calc(100% - 50px)",
  }),

  conflictDialogRoot: (props) => ({
    ...customTheme(props.theme).dialog.root,
    minWidth: "850px",
  }),

  title: customTheme().dialog.title,
  contentContainer: (props) => ({
    ...customTheme().dialog.contentContainer,
    ...customTheme(props.theme).customScrollBar,
    overflowY: "hidden",
    width: "100%",
    padding: "8px 0px",
  }),
  conflictDialogContentContainer: (props) => ({
    ...customTheme().dialog.contentContainer,
    alignItems: "center",
  }),

  contentItem: {
    ...customTheme().dialog.contentItem,
    margin: "0px",
  },
  buttonContainer: customTheme().dialog.buttonContainer,
  buttonOutlined: (props) => ({
    width: "110px",
    ...customTheme(props.theme).buttonOutlined,
  }),
  buttonExport: (props) => ({
    width: "170px",
    minHeight: "36.5px",
    ...customTheme(props.theme).buttonPrimary,
  }),
  tableContainer: (props) => ({
    marginTop: "15px",
    height: "calc(100% - 230px)",
    maxHeight: "calc(100% - 230px)",
    "@media only screen and (max-width: 900px)": {
      height: "calc(100% - 230px)",
      maxHeight: "calc(100% - 230px)",
    },
    overflowY: "auto",
    ...customTheme(props.theme).customScrollBar,
  }),
  headerCell: {
    backgroundColor: (props) => colors[props.theme].tableHeader,
    padding: "5px 0px 5px 0px",
  },
  dataCell: {
    padding: "5px 0px 5px 0px",
    backgroundColor: (props) => colors[props.theme].tableSubRow,
  },
  noData: {
    textAlign: "center",
    marginTop: "50px",
  },
  checkBox: {
    minWidth: "50px",
    padding: "0px",
  },
  tablePaperRoot: {
    height: "100%",
    width: "100%",
    borderRadius: "0px",
    boxShadow: "unset",
    backgroundColor: (props) => colors[props.theme].dialogBkg,
  },
  centerText: {
    display: "flex",
    justifyContent: "center",
    margin: "50px",
  },
  icon: customTheme().icon,
  activeSortIcon: {
    opacity: 1,
  },
  inActiveSortIcon: {
    opacity: 0.2,
  },
  progressCircle: {
    color: "rgba(255,255,255,1)",
  },
  progressLabel: {
    fontSize: "0.9rem",
  },
  exportLogCheckbox: {
    marginLeft: "5px",
  },
  studyListItem: {
    padding: "0px",
  },
  studyList: (props) => ({
    width: "80%",
    overflowY: "auto",
    padding: "35px 0px 35px 0px",
    ...customTheme(props.theme).customScrollBar,
  }),

  progressIndicatorDiv: {
    display: "flex",
    justifyContent: "center",
    marginTop: "15px",
    flexDirection: "column",
    alignItems: "center",
  },
  progressIndicatorText: {
    width: "350px",
    paddingTop: "15px",
    textAlign: "center",
  },
});

const SyncStudiesDialog = (props) => {
  const classes = useStyles(props);
  const columnStudies = [
    {
      title: "Participant ID",
      field: "participantId",
      // minWidth: "140px",
      // paddingLeft: "20px",
    },
    {
      title: "Protocol Name",
      field: "protocolName",
      // minWidth: "180px",
    },
    { title: "Date", field: "studyDate", minWidth: "110px" },
    {
      title: "User", //change the "user" to administrator?, credentials?
      field: "username",
      // minWidth: "120px",
    },
    {
      title: "Progress",
      field: "progress",
      // minWidth: "120px",
    },
    {
      title: "Status",
      field: "status",
      // minWidth: "60px",
    },
  ];

  useEffect(() => {
    if (props.localStudiesReceived && !props.remoteStudiesReceived) {
      setLocalState({
        ...localState,
        selected: props.localStudyAllIds,
      });
    } else if (props.localStudiesReceived && props.remoteStudiesReceived) {
      let selectedArray = [...props.localStudyAllIds];
      selectedArray = selectedArray.filter((studyId) => {
        let selectedStudy = props.localStudyInfoTableData.filter(
          (studyDetail) => studyDetail.id === studyId
        )[0];
        return [remoteStatus.localVersion, remoteStatus.local].includes(
          selectedStudy.status
        );
      });
      setLocalState({
        ...localState,
        selected: selectedArray,
      });
    }
  }, [props.localStudiesReceived, props.remoteStudiesReceived]);

  // useEffect(() => {
  //   props.eventSource.addEventListener("progress_indicator", handleEvent);
  //   return () => {
  //     props.eventSource.removeEventListener("progress_indicator", handleEvent);
  //   };
  // }, []);

  const getWindowSize = () => {
    let newDataTableSize = window.innerHeight;
    if (window.innerHeight > 600) {
      newDataTableSize = window.innerHeight - 405; // These numbers are based on dialog size
    } else {
      newDataTableSize = window.innerHeight - 300; // These numbers are based on dialog size
    }
    return newDataTableSize;
  };

  useEffect(() => {
    // Measure window size and dynamicaly change the size of the data table
    const handleResize = () => {
      setLocalState({ ...localState, windowSize: getWindowSize() });
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []); // Empty array ensures that effect is only run on mount and unmount

  const [localState, setLocalState] = React.useState({
    selected: [],
    windowSize: getWindowSize(),
    order: "asc",
    exportLog: false,
    overwriteNewerCloudVersion: false,
    orderBy: null,
    syncConflictDialogOpen: false,
    cloudConflictStudies: [],
  });
  const [progressIndicator, setProgressIndicator] = React.useState({
    value: 0,
    message: null,
  });
  const handleClickSync = () => {
    let cloudConflictStudies = [];
    for (let selectedStudyId of localState.selected) {
      let selectedStudy = props.localStudyInfoTableData.filter(
        (studyDetail) => studyDetail.id === selectedStudyId
      )[0];

      if ([remoteStatus.divergent].includes(selectedStudy.status)) {
        cloudConflictStudies.push(selectedStudyId);
      }
    }
    if (cloudConflictStudies.length !== 0) {
      setLocalState({
        ...localState,
        syncConflictDialogOpen: true,
        cloudConflictStudies: cloudConflictStudies,
      });
    } else {
      props.fetchPushStudyToRemote(localState.selected, localState.exportLog);
    }
  };

  const handleToggleOverwriteNewerCloudVersion = () => {
    let newSelectedArray = [...localState.selected];
    if (localState.overwriteNewerCloudVersion) {
      newSelectedArray = newSelectedArray.filter((studyId) => {
        let selectedStudy = props.localStudyInfoTableData.filter(
          (studyDetail) => studyDetail.id === studyId
        )[0];
        return selectedStudy.status !== remoteStatus.remoteVersion;
      });
    }
    setLocalState({
      ...localState,
      selected: newSelectedArray,
      overwriteNewerCloudVersion: !localState.overwriteNewerCloudVersion,
    });
  };

  const handleSelectAllClick = (event) => {
    let newSelecteds = [];
    if (event.target.checked) {
      newSelecteds = [
        ...props.localStudyInfoTableData.map((study) => study.id),
      ];
    }
    if (event.target.checked && !localState.overwriteNewerCloudVersion) {
      newSelecteds = newSelecteds.filter((studyId) => {
        let selectedStudy = props.localStudyInfoTableData.filter(
          (studyDetail) => studyDetail.id === studyId
        )[0];
        return selectedStudy.status !== remoteStatus.remoteVersion;
      });
    }
    setLocalState({ ...localState, selected: newSelecteds });
  };

  const handleStudyCheckboxClick = (event, studyId) => {
    let newSelecteds;
    if (event.target.checked) {
      newSelecteds = [...localState.selected, studyId];
    } else {
      newSelecteds = localState.selected.filter((id) => {
        return id !== studyId;
      });
    }
    setLocalState({ ...localState, selected: newSelecteds });
  };

  const requestSort = (property) => (event) => {
    const isAsc = localState.orderBy === property && localState.order === "asc";
    setLocalState({
      ...localState,
      order: isAsc ? "desc" : "asc",
      orderBy: property,
    });
  };

  function descendingComparator(a, b, orderBy) {
    if (orderBy === "progress") {
      // Need a special case for the progress because progress can be a number (percentage) or NA
      let numA = a[orderBy];
      let numB = b[orderBy];
      if (a[orderBy] !== "NA") {
        numA = Number(a[orderBy].slice(0, -1));
      } else if (a[orderBy] === "NA") {
        numA = -1;
      }
      if (b[orderBy] !== "NA") {
        numB = Number(b[orderBy].slice(0, -1));
      } else if (b[orderBy] === "NA") {
        numB = -1;
      }
      if (numB < numA) {
        return -1;
      }
      if (numB > numA) {
        return 1;
      }
      return 0;
    } else if (orderBy === "studyDate") {
      let dateNumA = Number(
        a[orderBy].split("/")[2] +
          a[orderBy].split("/")[0] +
          a[orderBy].split("/")[1]
      );
      let dateNumB = Number(
        b[orderBy].split("/")[2] +
          b[orderBy].split("/")[0] +
          b[orderBy].split("/")[1]
      );
      if (dateNumB < dateNumA) {
        return -1;
      }
      if (dateNumB > dateNumA) {
        return 1;
      }
      return 0;
    } else {
      if (b[orderBy] < a[orderBy]) {
        return -1;
      }
      if (b[orderBy] > a[orderBy]) {
        return 1;
      }
      return 0;
    }
  }
  const handleEvent = (e) => {
    switch (e.type) {
      case "progress_indicator":
        let data = JSON.parse(e.data);
        setProgressIndicator({
          value: data.value * 100,
          message: data.message,
        });
        break;
      default:
    }
  };

  function stableSort(array) {
    const stabilizedThis = array.map((el, index) => [el, index]);

    stabilizedThis.sort((a, b) => {
      if (localState.order === "desc") {
        return descendingComparator(a[0], b[0], localState.orderBy);
      } else {
        return -descendingComparator(a[0], b[0], localState.orderBy);
      }
    });
    return stabilizedThis.map((el) => el[0]);
  }

  return (
    <React.Fragment>
      <Dialog
        open={props.open}
        PaperProps={{ className: classNames(classes.root) }}
        disableBackdropClick={true}
      >
        <Typography
          className={classes.title}
          variant="h4"
          color="textPrimary"
          align="center"
        >
          Sync Studies to Cloud
        </Typography>

        <DialogContent className={classes.contentContainer}>
          <Typography
            className={classes.contentItem}
            color="textPrimary"
            align="center"
          >
            Upload studies to the cloud for remote access. The study data will
            remain on the device after syncing. Syncing studies may take a
            while.
          </Typography>

          <FormControlLabel
            className={classes.exportLogCheckbox}
            control={
              <Checkbox
                color="primary"
                onChange={() => handleToggleOverwriteNewerCloudVersion()}
                checked={!localState.overwriteNewerCloudVersion}
                value={!localState.overwriteNewerCloudVersion}
              />
            }
            label="Do not overwrite cloud if the local study is older."
          />

          <FormControlLabel
            className={classes.exportLogCheckbox}
            control={
              <Checkbox
                color="primary"
                onChange={() =>
                  setLocalState({
                    ...localState,
                    exportLog: !localState.exportLog,
                  })
                }
                checked={localState.exportLog}
                value={localState.exportLog}
              />
            }
            label="Upload log files."
          />

          <Paper className={classes.tablePaperRoot}>
            {!props.localStudiesReceived ? (
              <div className={classes.centerText}>
                <CircularProgress className={classes.icon} size={25} />
                <Typography>Loading...</Typography>
              </div>
            ) : props.localStudyAllIds.length === 0 ? (
              <Typography className={classes.noData}>No study found</Typography>
            ) : (
              <TableContainer
                className={classes.tableContainer}
                style={{
                  maxHeight: localState.windowSize,
                  height: localState.windowSize,
                }}
              >
                <Table stickyHeader size="small">
                  {/* TABLE HEADER */}
                  <TableHead>
                    <TableRow>
                      <TableCell
                        className={classes.headerCell}
                        key={"headerCheckbox"}
                        align="left"
                      >
                        <Checkbox
                          className={classes.checkBox}
                          color="primary"
                          indeterminate={
                            localState.selected.length > 0 &&
                            localState.selected.length <
                              Object.keys(props.localStudyInfoTableData).length
                          }
                          checked={
                            Object.keys(props.localStudyInfoTableData).length >
                              0 &&
                            localState.selected.length ===
                              Object.keys(props.localStudyInfoTableData).length
                          }
                          onChange={(e) => handleSelectAllClick(e)}
                        />
                      </TableCell>
                      {columnStudies.map((header) => (
                        <TableCell
                          className={classes.headerCell}
                          key={header.field}
                          align="left"
                          sortDirection={
                            localState.orderBy === header.field
                              ? localState.order
                              : false
                          }
                        >
                          <TableSortLabel
                            active={localState.orderBy === header.field}
                            direction={
                              localState.orderBy === header.field
                                ? localState.order
                                : "asc"
                            }
                            onClick={requestSort(header.field)}
                            classes={{
                              // Override icon class based on activation state
                              icon:
                                localState.orderBy === header.field
                                  ? classes.activeSortIcon
                                  : classes.inActiveSortIcon,
                            }}
                          >
                            {header.title}
                          </TableSortLabel>
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {stableSort(props.localStudyInfoTableData).map(
                      (row, index) => (
                        <TableRow
                          key={row.id}
                          style={{
                            backgroundColor: localState.selected.includes(
                              row.id
                            )
                              ? colors[props.theme].tableHover
                              : "unset",
                          }}
                        >
                          <TableCell
                            className={classes.dataCell}
                            key={row.id + "Checkbox"}
                            align="left"
                          >
                            <Checkbox
                              className={classes.checkBox}
                              color="primary"
                              disabled={
                                !localState.overwriteNewerCloudVersion &&
                                row.status === remoteStatus.remoteVersion
                              }
                              checked={localState.selected.includes(row.id)}
                              onClick={(e) =>
                                handleStudyCheckboxClick(e, row.id)
                              }
                            />
                          </TableCell>
                          {columnStudies.map((header) => (
                            <TableCell
                              className={classes.dataCell}
                              key={header.field}
                              align="left"
                            >
                              {header.field === "status"
                                ? getCloudStatusIcon(row[header.field])
                                : row[header.field]}
                            </TableCell>
                          ))}
                        </TableRow>
                      )
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </Paper>
        </DialogContent>

        <DialogActions className={classes.buttonContainer}>
          <Button
            disabled={props.requestSyncStudies}
            onClick={() => props.onClose()}
            className={classes.buttonOutlined}
            variant="outlined"
          >
            Cancel
          </Button>
          <Button
            onClick={() => handleClickSync()}
            className={classes.buttonExport}
            variant="contained"
            color="primary"
            disabled={
              props.requestSyncStudies ||
              localState.selected.length === 0 ||
              !props.remoteStudiesReceived
            }
          >
            Sync Studies
          </Button>
        </DialogActions>

        {props.requestSyncStudies && (
          <div className={classes.progressIndicatorDiv}>
            <Box
              className={classes.progressCircle}
              position="relative"
              display="inline-flex"
            >
              <CircularProgress
                size={38}
                variant="static"
                value={progressIndicator.value}
              />
              <Box
                top={0}
                left={0}
                bottom={0}
                right={0}
                position="absolute"
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <Typography
                  className={classes.progressLabel}
                  variant="caption"
                  component="div"
                >{`${Math.round(progressIndicator.value)}%`}</Typography>
              </Box>
            </Box>

            <Typography>
              {progressIndicator.message !== null
                ? progressIndicator.message
                : "Syncing..."}
            </Typography>
          </div>
        )}
      </Dialog>

      {localState.syncConflictDialogOpen && (
        <Dialog
          open={localState.syncConflictDialogOpen}
          PaperProps={{ className: classNames(classes.conflictDialogRoot) }}
        >
          <Typography
            variant="h4"
            color="textPrimary"
            align="center"
            className={classes.title}
          >
            Merge Conflict: Divergent Local and Cloud Versions
          </Typography>
          <DialogContent className={classes.conflictDialogContentContainer}>
            <Typography
              className={classes.contentItem}
              color="textPrimary"
              align="center"
            >
              For the studies listed below, a different version of the study
              exists on the cloud. The local version and the cloud version were
              independently modified after the last sync point and cannot be
              merged. Syncing the study will overwrite the cloud version. This
              cannot be undone. Do you want to continue with the sync?
            </Typography>
            <List className={classes.studyList}>
              {localState.cloudConflictStudies.map((studyId) => {
                let studyIndex = props.localStudyInfoTableData.findIndex(
                  (studyDict) => studyDict.id === studyId
                );
                return (
                  <ListItem className={classes.studyListItem} key={studyId}>
                    <ListItemText
                      primary={`Protocol Name:
                          ${props.localStudyInfoTableData[studyIndex].protocolName}`}
                      secondary={`Study Date:
                          ${props.localStudyInfoTableData[studyIndex].studyDate}`}
                    />
                  </ListItem>
                );
              })}
            </List>
          </DialogContent>

          <DialogActions className={classes.buttonContainer}>
            <Button
              className={classes.buttonOutlined}
              onClick={() =>
                setLocalState({
                  ...localState,
                  syncConflictDialogOpen: false,
                  cloudConflictStudies: [],
                })
              }
              variant="outlined"
            >
              Cancel
            </Button>

            <Button
              onClick={() => {
                setLocalState({
                  ...localState,
                  syncConflictDialogOpen: false,
                  cloudConflictStudies: [],
                });
                props.fetchPushStudyToRemote(
                  localState.selected,
                  localState.exportLog
                );
              }}
              variant="contained"
              color="primary"
              className={classes.buttonPrimary}
            >
              Continue
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </React.Fragment>
  );
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      fetchPushStudyToRemote,
    },
    dispatch
  );
};
// this uses the reselect library
// memoizes the (expensive) filter calculation and only updates it when one of its input variables changes
const reshapeLocalStudies = createSelector(
  [
    (state) => state.availableStudies.localStudyInfoById,
    (state) => state.availableStudies.remoteStudyInfoById,
  ],
  (localStudyInfoById, remoteStudyInfoById) => {
    return Object.keys(localStudyInfoById).map((studyId) => {
      let study = localStudyInfoById[studyId];
      let status;
      if (Object.keys(remoteStudyInfoById).includes(studyId)) {
        let remoteCopy = remoteStudyInfoById[studyId];
        if (
          remoteCopy.studyHash &&
          study.studyHash &&
          remoteCopy.studyHash.length !== 0 &&
          study.studyHash.length !== 0
        ) {
          let remoteHash = remoteCopy.studyHash.map((hash) => {
            return Object.keys(hash)[0];
          });
          let localHash = study.studyHash.map((hash) => {
            return Object.keys(hash)[0];
          });

          if (remoteHash[0] === localHash[0]) {
            status = remoteStatus.match;
          } else if (localHash.includes(remoteHash[0])) {
            status = remoteStatus.localVersion;
          } else if (remoteHash.includes(localHash[0])) {
            status = remoteStatus.remoteVersion;
          } else {
            status = remoteStatus.divergent;
          }
        } else {
          status = remoteStatus.divergent;
        }
      } else {
        status = remoteStatus.local;
      }

      return {
        id: studyId,
        participantId: study.participantId,
        protocolName: study.protocolName,
        username: study.username,
        progress: study.progress === null ? "NA" : study.progress + "%",
        studyDate: study.studyDate,
        study_filepath: study.study_filepath,
        studyHash: study.studyHash ? study.studyHash : [],
        status: status,
      };
    });
  }
);
const mapStateToProps = (state) => {
  return {
    localStudyInfoTableData: reshapeLocalStudies(state),
    localStudyAllIds: state.availableStudies.localStudyAllIds,
    localStudiesReceived: state.availableStudies.localStudiesReceived,
    remoteStudiesReceived: state.availableStudies.remoteStudiesReceived,
    requestSyncStudies: state.utility.requestSyncStudies,
    theme: state.utility.theme,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SyncStudiesDialog);
